/* eslint-disable */
import { BiShoppingBag, BiPencil } from "react-icons/bi";
import { BsCodeSlash, BsClipboardData } from "react-icons/bs";
import { AiOutlineMail, AiFillAudio } from "react-icons/ai";
import { IoBookSharp } from "react-icons/io5"
import {
  FaInternetExplorer,
  FaChalkboardTeacher,
  FaCameraRetro,
 
  FaPinterest,
  FaVideo,
  FaTabletAlt,
  FaRegNewspaper,
} from "react-icons/fa";

export const servicesData = [
  {
    id: 2,
    title: "Web Design",
    icon: <BiPencil />,
  },
  {
    id: 6,
    title: "Coding",
    icon: <BsCodeSlash />,
  },
  {
    id: 7,
    title: "Reading Novel",
    // icon: <FaCameraRetro />,
    icon: <IoBookSharp />,
  },
];
